import AvayaImg  from "../image/avayaLogo.png"
import MondeeImg  from "../image/mondee.png"
import InaipiImg  from "../image/inaipi.png"
import KonnectImg  from "../image/konnect.png"

export const partner_list = 
[
    {
        image:AvayaImg,
        description:"As an Avaya DevConnect Technology Partner, Diamond Partner, and APS Delivery Partner, we are at the forefront of delivering innovative communication solutions. Our partnership allows us to sell Avaya solutions- IP Telephony, UC and CC solutions, while Avaya also resells our groundbreaking solutions to their global partner community. Together, we are driving the future of customer engagement.",
        link:"https://imperiumapp.com/cx",
        width:"130px",
        alt:"Avaya"
    },
    {
        image:MondeeImg,
        description:"As a Development Partner and System Integrator for Mondee's advanced AI Chatbot solutions, we are pushing the boundaries of AI-driven customer engagement. Our collaboration ensures businesses can leverage cutting-edge chatbot technology to offer personalized, efficient, and seamless customer experiences.",
        link:"https://www.mondee.com",
        alt:"Mondee"
    },
    {
        image:KonnectImg,
        description:"Our partnership with Konnect Insights allows us to offer an all-in-one social media engagement platform that unifies customer care and market insights. This powerful platform enables businesses to monitor, manage, and engage with their audience across multiple channels, ensuring a cohesive and responsive customer experience.",
        link:"https://konnectinsights.com",
        width:"180px",
        alt:"Konnect"
    },
    {
        image:InaipiImg,
        description:"We deliver Inaipi’s innovative cloud, digital contact center solutions, UCaaS, CCaaS, and SaaS offerings. This partnership enables us to provide our clients with advanced, flexible, and scalable solutions that enhance customer interactions and streamline operations.",
        link:"https://inaipiapp.com",
        alt:"inaipi"
    },
    {
        image:"https://d1ikk3qahjralr.cloudfront.net/v1/NewEdaya.png",
        description:"We have partnered with Edaya to bring exceptional hospitality solutions that elevate guest experiences. Through this collaboration, we offer state-of-the-art technology that enhances every touchpoint of the guest journey, ensuring satisfaction and loyalty in the hospitality industry.",
        link:"https://edayaapp.com",
        alt:"edaya"
    },
    
]